<template>
  <b-row>
    <b-col cols="12">
      <tag-content />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import TagContent from './TagContent.vue'

export default {
  components: {
    BRow,
    BCol,

    TagContent
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>